module.exports = __webpack_public_path__ + "img/home-icon.b370b3ec.svg";